import React from 'react'
import { SvgIcon } from "@mui/material";

export default function SurveyIcon(props) {
  return (
    <SvgIcon
      x="0px"
      y="0px"
      viewBox="0 0 250 250"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fontSize="inherit"
      {...props}
    >
      <g fill="none">
        <rect
          width="132.442"
          height="132.442"
          rx="16"
          transform="matrix(0.866025 0.5 -0.866025 0.5 117.038 39.4231)"
          fill="#003026"
        />
        <path
          d="M130.894 3.31366C123.241 -1.10455 110.834 -1.10455 103.181 3.31366L6.86332 58.923C2.84012 61.2458 0.800189 63.8806 1.00698 66.9231L1.00687 67.423V82.423C1.57718 84.7719 3.73441 87.226 6.86332 89.0324L90.2432 137.172L104.507 145.923L105.507 146.423C113.166 149.613 124.001 148.622 130.894 144.642L226.507 89.9231C227.594 89.2959 229.229 88.1453 230.007 87.4231L231.007 86.4231L231.507 85.9231C232.932 84.1045 233.007 83.4231 233.007 81.4231L233.007 79.423V65.423L233.007 64.9231C232.426 62.5876 230.324 60.7197 227.212 58.923L130.894 3.31366Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.00708 70.823L4.00704 74.423L106.507 133.923L110.007 134.559V147.097C108.429 146.785 106.915 146.34 105.507 145.754L104.507 145.254L90.2434 136.503L6.86353 88.3635C3.73462 86.5571 1.57739 84.103 1.00708 81.7542V70.823Z"
          fill="#9B9BA8"
        />
        <path
          d="M2.00698 66.9233L2.00698 66.8893L2.00467 66.8553C1.83769 64.3984 3.44442 62.0516 7.36331 59.7891L103.681 4.17969C107.32 2.079 112.152 1 117.038 1C121.924 1 126.756 2.079 130.394 4.17969L226.712 59.7891L227.212 58.923L226.712 59.7891C229.735 61.5341 231.492 63.191 232.007 65.0517L232.007 65.4226V65.423V79.423L232.007 81.4231C232.007 82.4396 231.982 82.9654 231.835 83.4503C231.695 83.9114 231.418 84.41 230.757 85.2592L230.3 85.716L229.314 86.7023C228.601 87.3596 227.046 88.457 226.009 89.0561C226.008 89.0564 226.008 89.0567 226.007 89.0571L130.398 143.774L130.394 143.776C127.101 145.677 122.82 146.887 118.411 147.224C114.015 147.561 109.569 147.024 105.923 145.513L104.993 145.048L90.7661 136.319L90.7548 136.312L90.7432 136.306L7.36332 88.1664C4.41525 86.4644 2.53022 84.2506 2.00687 82.2976V67.4232V67.423L2.00698 66.9233Z"
          stroke="black"
          strokeWidth="2"
        />
        <mask id="path-5-inside-1_4009_219891" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.00712 66.0918C0.988222 66.365 0.988154 66.6415 1.00712 66.9215V66.0918ZM1.00712 67.8461V82.423C1.57743 84.7719 3.73465 87.226 6.86356 89.0324L90.2434 137.172L104.507 145.923L105.507 146.423C113.166 149.613 124.001 148.622 130.895 144.642L226.507 89.9231C227.594 89.2959 229.229 88.1452 230.007 87.4231L231.007 86.4231L231.507 85.9231C232.932 84.1045 233.007 83.4231 233.007 81.4231L233.007 79.423V67.0145C233.002 68.886 232.892 69.5795 231.507 71.3462L231.007 71.8462L230.007 72.8462C229.229 73.5683 227.594 74.719 226.507 75.3462L130.895 130.065C124.001 134.045 113.166 135.036 105.507 131.846L104.507 131.346L90.2434 122.595L6.86356 74.4555C3.73465 72.6491 1.57743 70.195 1.00712 67.8461Z"
          />
        </mask>
        <path
          d="M1.00712 66.0918H3.00712L-0.988118 65.9538L1.00712 66.0918ZM1.00712 66.9215L-0.988314 67.0566L3.00712 66.9215H1.00712ZM1.00712 67.8461L2.95065 67.3742L-0.992885 67.8461H1.00712ZM1.00712 82.423H-0.992885V82.6623L-0.936417 82.8949L1.00712 82.423ZM6.86356 89.0324L7.86356 87.3003L7.86353 87.3003L6.86356 89.0324ZM90.2434 137.172L91.2893 135.467L91.2666 135.453L91.2434 135.44L90.2434 137.172ZM104.507 145.923L103.461 147.628L103.535 147.673L103.613 147.712L104.507 145.923ZM105.507 146.423L104.613 148.212L104.675 148.243L104.738 148.269L105.507 146.423ZM130.895 144.642L129.901 142.906L129.895 142.91L130.895 144.642ZM226.507 89.9231L227.501 91.6589L227.507 91.6551L226.507 89.9231ZM230.007 87.4231L231.368 88.889L231.395 88.8636L231.422 88.8373L230.007 87.4231ZM231.507 85.9231L232.922 87.3373L233.007 87.2518L233.082 87.1566L231.507 85.9231ZM233.007 81.4231H235.007V81.4228L233.007 81.4231ZM233.007 79.423H231.007V79.4232L233.007 79.423ZM233.007 67.0145H235.007L231.007 67.009L233.007 67.0145ZM231.507 71.3462L232.922 72.7604L233.007 72.6749L233.082 72.5797L231.507 71.3462ZM230.007 72.8462L231.368 74.312L231.395 74.2867L231.422 74.2604L230.007 72.8462ZM226.507 75.3462L227.501 77.082L227.507 77.0782L226.507 75.3462ZM130.895 130.065L129.901 128.329L129.895 128.333L130.895 130.065ZM105.507 131.846L104.613 133.635L104.675 133.666L104.738 133.692L105.507 131.846ZM104.507 131.346L103.461 133.051L103.535 133.096L103.613 133.135L104.507 131.346ZM90.2434 122.595L91.2893 120.89L91.2666 120.876L91.2434 120.863L90.2434 122.595ZM6.86356 74.4555L7.86356 72.7234L7.86353 72.7234L6.86356 74.4555ZM-0.988118 65.9538C-1.01342 66.3196 -1.01332 66.6875 -0.988314 67.0566L3.00255 66.7864C2.98962 66.5956 2.98987 66.4103 3.00235 66.2298L-0.988118 65.9538ZM-0.992885 66.0918V66.9215H3.00712V66.0918H-0.992885ZM-0.992885 67.8461V82.423H3.00712V67.8461H-0.992885ZM-0.936417 82.8949C-0.186782 85.9823 2.4845 88.8136 5.86359 90.7644L7.86353 87.3003C4.98481 85.6383 3.34164 83.5614 2.95065 81.9511L-0.936417 82.8949ZM5.86356 90.7644L89.2434 138.904L91.2434 135.44L7.86356 87.3003L5.86356 90.7644ZM89.1975 138.876L103.461 147.628L105.553 144.218L91.2893 135.467L89.1975 138.876ZM103.613 147.712L104.613 148.212L106.402 144.634L105.401 144.134L103.613 147.712ZM104.738 148.269C108.923 150.012 113.875 150.58 118.641 150.215C123.407 149.851 128.141 148.541 131.895 146.374L129.895 142.91C126.755 144.723 122.625 145.899 118.335 146.227C114.046 146.555 109.751 146.024 106.276 144.577L104.738 148.269ZM131.888 146.378L227.501 91.6589L225.514 88.1872L129.901 142.906L131.888 146.378ZM227.507 91.6551C228.679 90.9789 230.448 89.7431 231.368 88.889L228.647 85.9572C228.011 86.5473 226.509 87.6128 225.507 88.191L227.507 91.6551ZM231.422 88.8373L232.422 87.8373L229.593 85.0088L228.593 86.0088L231.422 88.8373ZM232.422 87.8373L232.922 87.3373L230.093 84.5088L229.593 85.0088L232.422 87.8373ZM233.082 87.1566C233.843 86.1848 234.4 85.3267 234.705 84.3227C235.001 83.3496 235.007 82.39 235.007 81.4231H231.007C231.007 82.4561 230.976 82.8373 230.878 83.1594C230.79 83.4508 230.597 83.8427 229.933 84.6895L233.082 87.1566ZM235.007 81.4228L235.007 79.4228L231.007 79.4232L231.007 81.4233L235.007 81.4228ZM235.007 79.423V67.0145H231.007V79.423H235.007ZM233.082 72.5797C233.821 71.6366 234.369 70.7983 234.679 69.8299C234.985 68.8748 235.005 67.9499 235.007 67.0201L231.007 67.009C231.005 67.9507 230.966 68.3083 230.87 68.6094C230.778 68.8973 230.578 69.2891 229.933 70.1126L233.082 72.5797ZM232.422 73.2604L232.922 72.7604L230.093 69.9319L229.593 70.4319L232.422 73.2604ZM231.422 74.2604L232.422 73.2604L229.593 70.4319L228.593 71.4319L231.422 74.2604ZM227.507 77.0782C228.679 76.402 230.448 75.1662 231.368 74.312L228.647 71.3803C228.011 71.9704 226.509 73.0359 225.507 73.6141L227.507 77.0782ZM131.888 131.801L227.501 77.082L225.514 73.6103L129.901 128.329L131.888 131.801ZM104.738 133.692C108.923 135.435 113.875 136.003 118.641 135.638C123.407 135.274 128.141 133.964 131.895 131.797L129.895 128.333C126.755 130.146 122.625 131.322 118.335 131.65C114.046 131.979 109.751 131.447 106.276 130L104.738 133.692ZM103.613 133.135L104.613 133.635L106.402 130.057L105.401 129.557L103.613 133.135ZM89.1975 124.3L103.461 133.051L105.553 129.641L91.2893 120.89L89.1975 124.3ZM5.86356 76.1875L89.2434 124.327L91.2434 120.863L7.86356 72.7234L5.86356 76.1875ZM-0.936417 68.318C-0.186782 71.4054 2.4845 74.2367 5.86359 76.1875L7.86353 72.7234C4.98481 71.0614 3.34164 68.9845 2.95065 67.3742L-0.936417 68.318Z"
          fill="black"
          mask="url(#path-5-inside-1_4009_219891)"
        />
        <rect
          width="16.78"
          height="16.78"
          rx="1.52546"
          transform="matrix(-0.866025 0.5 0.866025 0.5 154.776 37.0579)"
          fill="#FAD2A0"
        />
        <path
          d="M143.547 51.931L74.8504 91.5929"
          stroke="black"
          strokeWidth="3.05092"
          strokeLinecap="round"
        />
        <rect
          width="16.78"
          height="16.78"
          rx="1.52546"
          transform="matrix(-0.866025 0.5 0.866025 0.5 174.592 48.4987)"
          fill="#FAD2A0"
        />
        <path
          d="M163.363 63.3719L94.6666 103.034"
          stroke="black"
          strokeWidth="3.05092"
          strokeLinecap="round"
        />
        <rect
          width="16.78"
          height="16.78"
          rx="1.52546"
          transform="matrix(-0.866025 0.5 0.866025 0.5 194.408 59.9396)"
          fill="#FAD2A0"
        />
        <path
          d="M183.179 74.8128L114.483 114.475"
          stroke="black"
          strokeWidth="3.05092"
          strokeLinecap="round"
        />
        <circle
          r="21.1574"
          transform="matrix(0.866025 -0.5 0.866025 0.5 60.3186 64.3339)"
          fill="#FAD2A0"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 60.8738 62.0898)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 60.8738 62.0898)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 60.8738 62.0898)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 60.8738 62.0898)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <path
          d="M57.0474 71.3517C62.4315 72.0901 68.3339 71.2468 72.5341 68.8218C76.7343 66.3968 78.195 62.989 76.916 59.8805L74.1787 61.4609C74.4855 63.6373 73.197 65.8745 70.3131 67.5395C67.4293 69.2045 63.5543 69.9484 59.7847 69.7713L57.0474 71.3517Z"
          fill="black"
        />
        <path
          d="M57.0474 71.3517C62.4315 72.0901 68.3339 71.2468 72.5341 68.8218C76.7343 66.3968 78.195 62.989 76.916 59.8805L74.1787 61.4609C74.4855 63.6373 73.197 65.8745 70.3131 67.5395C67.4293 69.2045 63.5543 69.9484 59.7847 69.7713L57.0474 71.3517Z"
          fill="black"
        />
        <path
          d="M57.0474 71.3517C62.4315 72.0901 68.3339 71.2468 72.5341 68.8218C76.7343 66.3968 78.195 62.989 76.916 59.8805L74.1787 61.4609C74.4855 63.6373 73.197 65.8745 70.3131 67.5395C67.4293 69.2045 63.5543 69.9484 59.7847 69.7713L57.0474 71.3517Z"
          fill="black"
        />
        <path
          d="M57.0474 71.3517C62.4315 72.0901 68.3339 71.2468 72.5341 68.8218C76.7343 66.3968 78.195 62.989 76.916 59.8805L74.1787 61.4609C74.4855 63.6373 73.197 65.8745 70.3131 67.5395C67.4293 69.2045 63.5543 69.9484 59.7847 69.7713L57.0474 71.3517Z"
          fill="black"
        />
        <circle
          r="3.20567"
          transform="matrix(0.866025 -0.5 0.866025 0.5 50.3244 64.975)"
          fill="black"
        />
        <circle
          r="3.20567"
          transform="matrix(0.866025 -0.5 0.866025 0.5 65.3158 56.3196)"
          fill="black"
        />
        <circle
          r="21.1574"
          transform="matrix(0.866025 -0.5 0.866025 0.5 113.162 33.8246)"
          fill="#FAD2A0"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 113.717 31.5806)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 113.717 31.5806)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 113.717 31.5806)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <circle
          r="19.8752"
          transform="matrix(0.866025 -0.5 0.866025 0.5 113.717 31.5806)"
          stroke="black"
          strokeWidth="2.56454"
        />
        <path
          d="M135.312 32.5771C129.928 31.8387 124.025 32.682 119.825 35.107C115.625 37.532 114.164 40.9398 115.443 44.0483L118.18 42.4679C117.874 40.2915 119.162 38.0543 122.046 36.3893C124.93 34.7243 128.805 33.9804 132.574 34.1575L135.312 32.5771Z"
          fill="black"
        />
        <path
          d="M135.312 32.5771C129.928 31.8387 124.025 32.682 119.825 35.107C115.625 37.532 114.164 40.9398 115.443 44.0483L118.18 42.4679C117.874 40.2915 119.162 38.0543 122.046 36.3893C124.93 34.7243 128.805 33.9804 132.574 34.1575L135.312 32.5771Z"
          fill="black"
        />
        <path
          d="M135.312 32.5771C129.928 31.8387 124.025 32.682 119.825 35.107C115.625 37.532 114.164 40.9398 115.443 44.0483L118.18 42.4679C117.874 40.2915 119.162 38.0543 122.046 36.3893C124.93 34.7243 128.805 33.9804 132.574 34.1575L135.312 32.5771Z"
          fill="black"
        />
        <path
          d="M135.312 32.5771C129.928 31.8387 124.025 32.682 119.825 35.107C115.625 37.532 114.164 40.9398 115.443 44.0483L118.18 42.4679C117.874 40.2915 119.162 38.0543 122.046 36.3893C124.93 34.7243 128.805 33.9804 132.574 34.1575L135.312 32.5771Z"
          fill="black"
        />
        <circle
          r="3.20567"
          transform="matrix(0.866025 -0.5 0.866025 0.5 103.168 34.4658)"
          fill="black"
        />
        <circle
          r="3.20567"
          transform="matrix(0.866025 -0.5 0.866025 0.5 118.159 25.8105)"
          fill="black"
        />
      </g>
    </SvgIcon>
  );
}
